export default __webpack_public_path__ + "static/media/rocket_anim_34.00d0aabf.png";